class DammiText extends HTMLElement {
  connectedCallback() {
    const en = this.getAttribute('en') || '';
    const lv = this.getAttribute('lv') || '';
    const it = this.getAttribute('it') || '';
    
    // Create a span with data attributes for translation
    const span = document.createElement('span');
    span.setAttribute('data-en', en);
    span.setAttribute('data-lv', lv);
    span.setAttribute('data-it', it);
    span.textContent = en; // Default to English
    
    this.appendChild(span);
  }
}

customElements.define('dammi-text', DammiText);

